@file:OptIn(org.jetbrains.compose.resources.InternalResourceApi::class)

package chartsproject.app.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi

private object CommonMainDrawable0 {
  public val ic_bar_chart: DrawableResource by 
      lazy { init_ic_bar_chart() }

  public val ic_check: DrawableResource by 
      lazy { init_ic_check() }

  public val ic_dark_mode: DrawableResource by 
      lazy { init_ic_dark_mode() }

  public val ic_github: DrawableResource by 
      lazy { init_ic_github() }

  public val ic_launcher_foreground: DrawableResource by 
      lazy { init_ic_launcher_foreground() }

  public val ic_line_chart: DrawableResource by 
      lazy { init_ic_line_chart() }

  public val ic_multi_line_chart: DrawableResource by 
      lazy { init_ic_multi_line_chart() }

  public val ic_pie_chart: DrawableResource by 
      lazy { init_ic_pie_chart() }

  public val ic_replay: DrawableResource by 
      lazy { init_ic_replay() }

  public val ic_stacked_bar_chart: DrawableResource by 
      lazy { init_ic_stacked_bar_chart() }

  public val ic_visibility_off: DrawableResource by 
      lazy { init_ic_visibility_off() }

  public val ic_visibility_on: DrawableResource by 
      lazy { init_ic_visibility_on() }
}

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("ic_bar_chart", CommonMainDrawable0.ic_bar_chart)
  map.put("ic_check", CommonMainDrawable0.ic_check)
  map.put("ic_dark_mode", CommonMainDrawable0.ic_dark_mode)
  map.put("ic_github", CommonMainDrawable0.ic_github)
  map.put("ic_launcher_foreground", CommonMainDrawable0.ic_launcher_foreground)
  map.put("ic_line_chart", CommonMainDrawable0.ic_line_chart)
  map.put("ic_multi_line_chart", CommonMainDrawable0.ic_multi_line_chart)
  map.put("ic_pie_chart", CommonMainDrawable0.ic_pie_chart)
  map.put("ic_replay", CommonMainDrawable0.ic_replay)
  map.put("ic_stacked_bar_chart", CommonMainDrawable0.ic_stacked_bar_chart)
  map.put("ic_visibility_off", CommonMainDrawable0.ic_visibility_off)
  map.put("ic_visibility_on", CommonMainDrawable0.ic_visibility_on)
}

internal val Res.drawable.ic_bar_chart: DrawableResource
  get() = CommonMainDrawable0.ic_bar_chart

private fun init_ic_bar_chart(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_bar_chart",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_bar_chart.xml", -1, -1),
    )
)

internal val Res.drawable.ic_check: DrawableResource
  get() = CommonMainDrawable0.ic_check

private fun init_ic_check(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_check",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_check.xml", -1, -1),
    )
)

internal val Res.drawable.ic_dark_mode: DrawableResource
  get() = CommonMainDrawable0.ic_dark_mode

private fun init_ic_dark_mode(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_dark_mode",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_dark_mode.xml", -1, -1),
    )
)

internal val Res.drawable.ic_github: DrawableResource
  get() = CommonMainDrawable0.ic_github

private fun init_ic_github(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_github",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_github.xml", -1, -1),
    )
)

internal val Res.drawable.ic_launcher_foreground: DrawableResource
  get() = CommonMainDrawable0.ic_launcher_foreground

private fun init_ic_launcher_foreground(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_launcher_foreground",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_launcher_foreground.xml", -1, -1),
    )
)

internal val Res.drawable.ic_line_chart: DrawableResource
  get() = CommonMainDrawable0.ic_line_chart

private fun init_ic_line_chart(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_line_chart",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_line_chart.xml", -1, -1),
    )
)

internal val Res.drawable.ic_multi_line_chart: DrawableResource
  get() = CommonMainDrawable0.ic_multi_line_chart

private fun init_ic_multi_line_chart(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_multi_line_chart",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_multi_line_chart.xml", -1, -1),
    )
)

internal val Res.drawable.ic_pie_chart: DrawableResource
  get() = CommonMainDrawable0.ic_pie_chart

private fun init_ic_pie_chart(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_pie_chart",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_pie_chart.xml", -1, -1),
    )
)

internal val Res.drawable.ic_replay: DrawableResource
  get() = CommonMainDrawable0.ic_replay

private fun init_ic_replay(): DrawableResource = org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_replay",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_replay.xml", -1, -1),
    )
)

internal val Res.drawable.ic_stacked_bar_chart: DrawableResource
  get() = CommonMainDrawable0.ic_stacked_bar_chart

private fun init_ic_stacked_bar_chart(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_stacked_bar_chart",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_stacked_bar_chart.xml", -1, -1),
    )
)

internal val Res.drawable.ic_visibility_off: DrawableResource
  get() = CommonMainDrawable0.ic_visibility_off

private fun init_ic_visibility_off(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_visibility_off",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_visibility_off.xml", -1, -1),
    )
)

internal val Res.drawable.ic_visibility_on: DrawableResource
  get() = CommonMainDrawable0.ic_visibility_on

private fun init_ic_visibility_on(): DrawableResource =
    org.jetbrains.compose.resources.DrawableResource(
  "drawable:ic_visibility_on",
    setOf(
      org.jetbrains.compose.resources.ResourceItem(setOf(),
    "composeResources/chartsproject.app.generated.resources/drawable/ic_visibility_on.xml", -1, -1),
    )
)
